import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import './index.css';
import PropTypes from 'prop-types';
import Registration from './Registration';
import {authenticateUser as authenticateUserAction} from '../../services/user/action';
import {addNotification as addNotificationAction} from '../../services/notification/action';
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import config from "../../config";

const Auth = (props) => {
    const {match, addNotification, user, authenticate} = props;
    const {params} = match;
    const {token} = params;
    const defaultProps = {
        addNotification,
    };
    const {pathname} = props.history.location || {};
    const loginComponentProps = {
        user,
        authenticate,
    };

    if (pathname === "/login" && user.isAuthenticated) {
        window.location.href = config.APP_HOST + "/dashboard"
    }

    return (
        <div className="centered-flex-container full-height auth-container">
            <div className="auth-shell">
                <div className="auth-form-container">
                    <div className="form-container">
                        <p className="auth-platform-title">Customer Support Platform</p>
                        {pathname === "/login" ? <Login {...loginComponentProps} /> :
                            pathname === "/forgot" ? <ForgotPassword {...defaultProps}/> :
                                pathname.includes("/reset-password") ? <ResetPassword {...defaultProps}/> :
                                    <Registration {...defaultProps} token={token}/>}
                    </div>
                </div>
            </div>
        </div>
    );
};

Auth.propTypes = {
    match: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
    addNotification: (message, level, config) => {
        dispatch(addNotificationAction(message, level, config));
    },
    authenticate: (token) => {
        dispatch(authenticateUserAction(token));
    },
});

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Auth));



// WEBPACK FOOTER //
// ./src/scenes/auth/index.jsx